import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

/**
 * JoinRedirectPage — /join?ref=TBC-XXXXXX
 * Captures the referral code, stashes it in sessionStorage so the auth
 * flow picks it up on submit, and bounces the visitor to the sign-up
 * dialog on the homepage.
 */
export default function JoinRedirectPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const ref = (params.get("ref") || "").trim();
    if (ref && /^TBC-[A-Z0-9]{6}$/i.test(ref)) {
      try {
        sessionStorage.setItem("tbc.pending_ref", ref.toUpperCase());
      } catch (e) {
        // sessionStorage unavailable; carry on
      }
    }
    // Send them to the landing page, opening the sign-up dialog via query param
    navigate("/?signup=1", { replace: true });
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-tbc-cream">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin mx-auto text-tbc-gold mb-3" />
        <p className="text-tbc-navy font-body">Welcome to The Blk Community…</p>
      </div>
    </div>
  );
}
